// extracted by mini-css-extract-plugin
export var subtitle = "_cg-2";
export var title = "_cg-0";
export var titleNoWrap = "_cg-1";